import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import PeopleIcon from '@material-ui/icons/People';
import SettingsIcon from '@material-ui/icons/Settings';
import DnsIcon from '@material-ui/icons/Dns';
// import ViewCarouselIcon from '@material-ui/icons/ViewCarousel';
// import EventNoteIcon from '@material-ui/icons/EventNote';
import { Link } from 'react-router-dom';
import BrandingWatermarkIcon from '@material-ui/icons/BrandingWatermark';
// import CategoryIcon from '@material-ui/icons/Category';
import PersonPinCircleIcon from '@material-ui/icons/PersonPinCircle';

export const mainListItems = (
  <div>
    <Link to="/main/users">
        <ListItem button>
          <ListItemIcon>
              <PeopleIcon />
          </ListItemIcon>
          <ListItemText primary="کاربران" />
        </ListItem>
    </Link>
    <Link to="/main/posts">
      <ListItem button>
        <ListItemIcon>
          <ShoppingCartIcon />
        </ListItemIcon>
        <ListItemText primary="پست ها" />
      </ListItem>
    </Link>
    <Link to="/main/brands">
      <ListItem button>
        <ListItemIcon>
          <ShoppingCartIcon />
        </ListItemIcon>
        <ListItemText primary="برندها" />
      </ListItem>
    </Link>
    <Link to="/main/activities">
      <ListItem button>
        <ListItemIcon>
          <DnsIcon />
        </ListItemIcon>
        <ListItemText primary="خصوصیات" />
      </ListItem>
    </Link>
    <Link to="/main/conversations">
      <ListItem button>
        <ListItemIcon>
          <BrandingWatermarkIcon />
        </ListItemIcon>
        <ListItemText primary="مکالمات" />
      </ListItem>
    </Link>
    <Link to="/main/productTypes">
      <ListItem button>
        <ListItemIcon>
          <SettingsIcon />
        </ListItemIcon>
        <ListItemText primary="دسته بندی ها" />
      </ListItem>
    </Link>
    {/* <Link to="/main/offers">
      <ListItem button>
        <ListItemIcon>
          <PersonPinCircleIcon />
        </ListItemIcon>
        <ListItemText primary="پیشنهادات ویژه" />
      </ListItem>
    </Link> */}
    <Link to="/main/purchases">
      <ListItem button>
        <ListItemIcon>
          <PersonPinCircleIcon />
        </ListItemIcon>
        <ListItemText primary="سفارشات" />
      </ListItem>
    </Link>
    <Link to="/main/products">
      <ListItem button>
        <ListItemIcon>
          <PersonPinCircleIcon />
        </ListItemIcon>
        <ListItemText primary="محصولات" />
      </ListItem>
    </Link>
    <Link to="/main/settings">
      <ListItem button>
        <ListItemIcon>
          <PersonPinCircleIcon />
        </ListItemIcon>
        <ListItemText primary="تنظیمات" />
      </ListItem>
    </Link>
    <Link to="/main/subjects">
      <ListItem button>
        <ListItemIcon>
          <PersonPinCircleIcon />
        </ListItemIcon>
        <ListItemText primary="موضوع مکالمات" />
      </ListItem>
    </Link>
  </div>
);
